import { API } from '@Providers';

interface ApplyRetailPresetDiscountPayload {
  code: string;
}

export default async function applyRetailPresetDiscount(payload: ApplyRetailPresetDiscountPayload) {
  const endpoint = '/api/shelter/cart/apply-retail-preset-discount/';

  return API({ endpoint, method: 'put', payload });
}
